import { BasicClient } from '@/utils/httpClient'

export default class UsersLink {
  client
  constructor() {
    this.client = new BasicClient()
  }

  checkUsersLink() {
    return this.client.exec('/v2/user-link/candidates', 'GET')
  }

  sendLinkEmail(data) {
    let params = data
    return this.client.exec('/v2/user-link/request', 'POST', params)
  }

  checkTokenValidity(token) {
    return this.client.requestWithoutJWT(`/v2/user-link/${token}`, 'GET')
  }

  linkUserByEmail(token){
    return this.client.requestWithoutJWT(`/v2/user-link/email/${token}`, 'PATCH')
  }

  linkUserByPassword(token, password){
    return this.client.requestWithoutJWT(`/v2/user-link/password/${token}`, 'PATCH', { pass: password})
  }
  rememberLater() {
    return this.client.exec('/v2/user-link/remember-later', 'POST')
  }

  checkCandidateCredentials(user,password) { 
    return this.client.exec('/v2/user-link/candidate/credentials', 'POST', {userId: user, password: password})
  }

  postValidationCode(userId,code) {
    return this.client.exec('/v2/user-link/email/validation', 'POST', {userId: userId, code: code})
  }

  reSendValidationCode (userId,email = null) {
    let data = {userId: userId};
    if (email) {
      data.email = email;
    }
    return this.client.exec('/v2/user-link/email/code', 'POST', data)
  }

  executeLinking(data) {
    return this.client.exec('/v2/user-link/execute', 'POST', data)
  }

  excludeCandidate(userId,reason) {
    return this.client.exec('/v2/user-link/exclude', 'POST', {idAccount: userId, reason: reason})
  }
}
